



















































import Vue from 'vue';
import StoreAlert from '@/components/StoreAlert.vue';
import {SortOption, TableData, TableOptions, User} from '@/types';
import UserCard from '@/components/cards/UserCard.vue';

function defaultOptions(): TableOptions {
  return {
    sortBy: ['id'],
    sortDesc: [true],
    page: 1,
    itemsPerPage: 20
  };
}

export default Vue.extend({
  name: 'Users',
  components: {UserCard, StoreAlert},
  data(): TableData<User> {
    return {
      headers: [
        {value: 'id', text: 'ID'},
        {value: 'name', text: 'Name'},
        {value: 'email', text: 'Email'},
        {value: 'roles', text: 'Roles'},
        {value: 'created_at', text: 'Created at'},
        {value: 'updated_at', text: 'Updated at'}
      ],
      items: [],
      options: defaultOptions(),
      aggregate: undefined,
      total: 0,
      expanded: []
    };
  },
  watch: {
    $hash() {
      this.$store.updateTableOptions(this.options, defaultOptions());
      this.load();
    }
  },
  computed: {
    sort(): SortOption[] {
      const {sortBy, sortDesc} = this.options;
      return (sortBy as string[]).map((column, i) => {
        return {
          column: `users.${column}`,
          order: sortDesc[i] ? 'desc' : 'asc'
        };
      });
    }
  },
  methods: {
    updateOptions(options: TableOptions) {
      this.$store.setTableOptions(options, defaultOptions());
    },
    load() {
      this.cleanError();
      this.startLoading();

      const {page, itemsPerPage} = this.options;
      const where = Object.assign({}, this.$store.query) as Record<string, unknown>;
      if (typeof where.license_types === 'string') {
        where.license_types = where.license_types.split(',');
      }

      return this.$store.api.users({
        where,
        sort: this.sort,
        page,
        perPage: itemsPerPage
      }).then(({items, total, aggregate}) => {
        this.stopLoading();
        this.items = items;
        this.total = total;
        this.aggregate = aggregate;
      }).catch(this.setError);
    }
  },
  created() {
    this.$store.updateTableOptions(this.options, defaultOptions());
    this.load();
  }
});
